import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn.js';
const sizeStyles = {
    xs: { container: 'h-3 w-3', spinner: 'border-[2px]' },
    sm: { container: 'h-4 w-4', spinner: 'border-[2px]' },
    md: { container: 'h-6 w-6', spinner: 'border-[2px]' },
    lg: { container: 'h-8 w-8', spinner: 'border-[3px]' },
    xl: { container: 'h-12 w-12', spinner: 'border-[3px]' },
};
export function Spinner({ size = 'md', color = 'currentColor', className, label, }) {
    const styles = sizeStyles[size];
    return (_jsxs("div", { className: cn('inline-flex flex-col items-center gap-2', className), role: "status", "aria-label": label || 'Loading', children: [_jsx("div", { className: cn('animate-spin rounded-full', 'border-transparent border-t-current border-r-current', styles.container, styles.spinner), style: { color }, children: _jsx("span", { className: "sr-only", children: label || 'Loading...' }) }), label && (_jsx("span", { className: "text-sm text-gray-500 dark:text-slate-400", children: label }))] }));
}
/**
 * Full Page Loading Spinner
 */
export function PageSpinner({ label = 'Loading...' }) {
    return (_jsx("div", { className: "fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50 dark:bg-slate-950/80", children: _jsx(Spinner, { size: "xl", label: label }) }));
}
/**
 * Inline Loading Spinner with Text
 */
export function LoadingText({ text = 'Loading...', size = 'sm', }) {
    return (_jsxs("div", { className: "inline-flex items-center gap-2 text-gray-500 dark:text-slate-400", children: [_jsx(Spinner, { size: size }), _jsx("span", { className: "text-sm", children: text })] }));
}
//# sourceMappingURL=Spinner.js.map